// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { ContentModule } from "../../common/content_module/ContentModule";
import { reaction } from "mobx";

@Observer
@Component({
  mixins: [template],
  components: {
    ContentModule,
  },
})
export class ProductTextModule extends ModuleBase {
  get bodyBuilder() {
    return this.$store.conversionWorld.bodyBuilder;
  }

  get product() {
    return this.$store.conversionWorldProduct.current;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get isAvailable() {
    if (this.product) {
      let allowedCountries = this.instance["land"];
      let productCountries = this.product.technical_data.countries.map(
        (x) => x.abbreviation
      );

      return (
        allowedCountries &&
        allowedCountries.filter((value) => productCountries.includes(value))
          .length > 0
      );
    }

    return true;
  }

  public get finalInstance() {
    let copy = JSON.parse(JSON.stringify(this.instance));

    let isVanSolution = false;
    if (this.bodyBuilder) {
      isVanSolution = this.bodyBuilder.type == "vansolution";
    } else if (this.product) {
      isVanSolution = this.product.is_van_solution;
    }

    if (!(copy["color"] && copy["color"] === "manuel")) {
      if (isVanSolution) {
        copy["text"]["section_color"]["color"] = "black";
      } else {
        copy["text"]["section_color"]["color"] = "white";
      }
    }

    copy["text"]["common_options"] = copy["common_options"];

    return copy["text"];
  }
}
